import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Typography } from "@mui/material";
import { Description, Update } from "@mui/icons-material";
import CardTable from "../../components/CardTable/CardTable";
import RegularButton from "../../components/CustomButtons/Button";
import { TableInputs } from "../../components/CardTable/TableInputs";
import { ModalV2 } from "../../components/Modal/ModalV2";
import { useSearch } from "../../hooks/useSearch";
import { useValidateReload } from "../../hooks/useValidateReload";
import { useToggle } from "../../hooks/useToggle";
import { dateValidator } from "../../helpers/dateValidator";
import { newDate } from "../../helpers/dateTools";
import {
  doNotesFiscalUpdate,
  getNotesFiscalUpdate,
  setNotesFiscalUpdateFilters,
  selectNextNotesFiscalUpdate,
} from "../../redux/actions/notesFiscalUpdate/notesFiscalUpdateActions";
import { columns } from "./columns";

export const NotesFiscalUpdate = () => {
  const { setSnackbar } = useSearch();
  const {
    station,
    startDate,
    endDate,
    notesFiscalUpdateArr,
    notesToFiscalUpdate,
  } = useSelector(({ notesFiscalUpdate }) => notesFiscalUpdate);
  const { isLoadingComp } = useSelector(({ search }) => search);
  const [isOver, setIsOver] = useState(false);
  const [openConfirm, setOpenConfirm] = useToggle();
  const limit = parseInt(process.env.REACT_APP_LIMIT_FETCH_NOTES) || 50;

  useValidateReload(["loadingNotesFiscalUpdate"]);
  const dispatch = useDispatch();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (dateValidator(startDate, endDate, 31, setSnackbar)) return;
    if (!station) {
      setSnackbar("No se ha seleccionado alguna planta.", "warning");
      return;
    }
    const stationID = station.id;
    dispatch(getNotesFiscalUpdate(stationID, startDate, endDate));
  };

  const handleUpdate = () => {
    dispatch(doNotesFiscalUpdate({ ids: Array.from(notesToFiscalUpdate.keys()) }, setOpenConfirm));
  };

  const handleSelectNextNotes = () => dispatch(selectNextNotesFiscalUpdate());

  useEffect(() => {
    const checkedNotes = Array.from(notesToFiscalUpdate.keys()).length;
    checkedNotes > limit ? setIsOver(true) : setIsOver(false);
  }, [notesToFiscalUpdate]);

  return (
    <>
      <CardTable
        hasHeader
        icon={<Description />}
        title="Notas para Actualización Fiscal"
        data={notesFiscalUpdateArr}
        columns={columns}
        isLoading={isLoadingComp?.loadingNotesFiscalUpdate}
        blockBtn
        hasControl
        controls={
          <Box
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {isOver && (
              <Typography
                variant="body1"
                color="error"
              >{`No se pueden migrar mas de ${limit} notas`}</Typography>
            )}
            {notesFiscalUpdateArr.length > 0 && (
              <RegularButton
                color="info"
                size="sm"
                onClick={handleSelectNextNotes}
                disabled={
                  notesToFiscalUpdate.size >= limit ||
                  isLoadingComp?.loadingNotesFiscalUpdate
                }
                loading={isLoadingComp?.loadingNotesFiscalUpdate}
              >
                Seleccionar 50 notas
              </RegularButton>
            )}
            <RegularButton
              round
              justIcon
              color="info"
              size="sm"
              onClick={setOpenConfirm}
              disabled={
                notesToFiscalUpdate.size === 0 ||
                isLoadingComp?.loadingNotesFiscalUpdate ||
                isOver
              }
              tooltip="Actualizar Notas"
              loading={isLoadingComp?.loadingNotesFiscalUpdate}
            >
              <Update style={{ margin: 0 }} />
            </RegularButton>
          </Box>
        }
        tableContent={
          <TableInputs
            reducer="notesFiscalUpdate"
            dates
            stations
            dispatchAction={setNotesFiscalUpdateFilters}
            submitLoadingKey="loadingNotesFiscalUpdate"
            submitAction={handleSubmit}
            maxDate={newDate()}
          />
        }
      />
      <ModalV2
        title="¿Seguro que desea actualizar notas?"
        open={openConfirm}
        onClose={setOpenConfirm}
        justConfirm
        onSubmit={handleUpdate}
      />
    </>
  );
};
